// import {
//   FETCH_USERPROFILEDATA_FAILURE,
//   FETCH_USERPROFILEDATA_REQUEST,
//   FETCH_USERPROFILEDATA_SUCCESS,
// } from "./userProfileDataActionTypes";

// const initialState = {
//   userDatas: [],
//   loading: false,
//   error: null,
// };

// const userProfileDataReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_USERPROFILEDATA_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };
//     case FETCH_USERPROFILEDATA_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         error: null,
//         userDatas: action.payload.data,
//       };
//     case FETCH_USERPROFILEDATA_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//         userDatas:[]
//       };
//     default:
//       return state;
//   }
// };

// export default userProfileDataReducer;
import {
  FETCH_USERPROFILEDATA_REQUEST,
  FETCH_USERPROFILEDATA_SUCCESS,
  FETCH_USERPROFILEDATA_FAILURE,
  CREATE_USERPROFILE_REQUEST,
  CREATE_USERPROFILE_SUCCESS,
  CREATE_USERPROFILE_FAILURE,
  UPDATE_USERPROFILE_REQUEST,
  UPDATE_USERPROFILE_SUCCESS,
  UPDATE_USERPROFILE_FAILURE,
  DELETE_USERPROFILE_REQUEST,
  DELETE_USERPROFILE_SUCCESS,
  DELETE_USERPROFILE_FAILURE,
} from "./userProfileDataActionTypes";

const initialState = {
  loading: false,
  userDatas: [],
  error: null,
};

const userProfileDataReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH
    case FETCH_USERPROFILEDATA_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USERPROFILEDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userDatas: action.payload.data,
      };
    case FETCH_USERPROFILEDATA_FAILURE:
      return { ...state, loading: false, error: action.payload, userDatas: [] };

    // CREATE
    case CREATE_USERPROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_USERPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userDatas: action.payload.data,
      };
    case CREATE_USERPROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case UPDATE_USERPROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_USERPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userDatas: action.payload.data,
      };
    case UPDATE_USERPROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // DELETE
    case DELETE_USERPROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_USERPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userDatas: action.payload.data,
      };
    case DELETE_USERPROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default userProfileDataReducer;
